import { useCallback, useRef } from 'react';
import { FirestoreDB } from '../../utils/firebase/firebase';
import { collection, onSnapshot, query, where } from 'firebase/firestore';

export const useNotificationEffects = (user, fetchNotifications) => {
  const groupsUnsubscribeRef = useRef(null);

  // Fetch groups for group chat notifications
  const fetchGroups = useCallback((user, setGroups, setLoading) => {
    if (!user?.uid) {
      setLoading(true);
      return () => {};
    }

    // Clean up existing listener if any
    if (groupsUnsubscribeRef.current) {
      groupsUnsubscribeRef.current();
      groupsUnsubscribeRef.current = null;
    }

    const groupCollection = collection(FirestoreDB, 'groupChats');
    const q = query(
      groupCollection,
      where('members', 'array-contains', user?.uid)
    );

    const unsubscribe = onSnapshot(q, (groupSnapshot) => {
      const groupList = groupSnapshot.docs.map((doc) => ({
        groupId: doc.id,
        ...doc.data(),
      }));
      setGroups(groupList);
      setLoading(false);
    });

    groupsUnsubscribeRef.current = unsubscribe;
    return unsubscribe;
  }, []);

  return { fetchGroups };
}; 